(function () {
  const bundleCodesES = {
    2: 'PACKMEDPINS2',
    3: 'PACKMEDPINS3',
    4: 'PACKMEDPINS4',
    5: 'PACKMEDPINS5',
    6: 'PACKMEDPINS6',
    7: 'PACKMEDPINS7',
    8: 'PACKMEDPINS8',
    9: 'PACKMEDPINS9',
    10: 'PACKMEDPINS10',
    11: 'PACKMEDPINS11',
    12: 'PACKMEDPINS12',
    13: 'PACKMEDPINS13',
    14: 'PACKMEDPINS14',
    15: 'PACKMEDPINS15',
    16: 'PACKMEDPINS16',
    17: 'PACKMEDPINS17',
    18: 'PACKMEDPINS18',
    19: 'PACKMEDPINS19',
    20: 'PACKMEDPINS20',
    21: 'PACKMEDPINS21',
    22: 'PACKMEDPINS22',
    23: 'PACKMEDPINS23',
    24: 'PACKMEDPINS24',
    25: 'PACKMEDPINS25',
    26: 'PACKMEDPINS26',
    27: 'PACKMEDPINS27',
    28: 'PACKMEDPINS28',
    29: 'PACKMEDPINS29',
    30: 'PACKMEDPINS30'
  };

  const bundleCodesDACH = {
    2: 'PACKDACH2',
    3: 'PACKDACH3',
    4: 'PACKDACH4',
    5: 'PACKDACH5',
    6: 'PACKDACH6',
    7: 'PACKDACH7',
    8: 'PACKDACH8',
    9: 'PACKDACH9',
    10: 'PACKDACH10',
    11: 'PACKDACH11',
    12: 'PACKDACH12',
    13: 'PACKDACH13',
    14: 'PACKDACH14',
    15: 'PACKDACH15',
    16: 'PACKDACH16',
    17: 'PACKDACH17',
    18: 'PACKDACH18',
    19: 'PACKDACH19',
    20: 'PACKDACH20',
    21: 'PACKDACH21',
    22: 'PACKDACH22',
    23: 'PACKDACH23',
    24: 'PACKDACH24',
    25: 'PACKDACH25',
    26: 'PACKDACH26',
    27: 'PACKDACH27',
    28: 'PACKDACH28',
    29: 'PACKDACH29',
    30: 'PACKDACH30'
  };

  const bundleCodesINT = {
    2: 'PACKINT2',
    3: 'PACKINT3',
    4: 'PACKINT4',
    5: 'PACKINT5',
    6: 'PACKINT6',
    7: 'PACKINT7',
    8: 'PACKINT8',
    9: 'PACKINT9',
    10: 'PACKINT10',
    11: 'PACKINT11',
    12: 'PACKINT12',
    13: 'PACKINT13',
    14: 'PACKINT14',
    15: 'PACKINT15',
    16: 'PACKINT16',
    17: 'PACKINT17',
    18: 'PACKINT18',
    19: 'PACKINT19',
    20: 'PACKINT20',
    21: 'PACKINT21',
    22: 'PACKINT22',
    23: 'PACKINT23',
    24: 'PACKINT24',
    25: 'PACKINT25',
    26: 'PACKINT26',
    27: 'PACKINT27',
    28: 'PACKINT28',
    29: 'PACKINT29',
    30: 'PACKINT30'
  };

  const premiumVariantIds = new Set([
    '63179921621341',
    '63179921654109',
    '63179931844957',
    '63179931877725',
    '63179934400861',
    '63214594883933',
    '63189883584861',
    '63189968290141',
    '63189968716125',
    '63214445429085',
    '63214445461853',
    '63214602518877',
    '63214445789533',
    '63214629126493',
    '63214628864349'
  ]);

  const eligibleProductIds = new Set([
    '15875236495709',
    '15877189042525',
    '15877237309789',
    '15877251596637',
    '15877255496029',
    '15882737975645',
    '15882778018141',
    '15883982963037',
    '15884052103517'
  ]);

  let syncing = null;

  function countryCode() {
    return String((window.Shopify && Shopify.country) || '').toUpperCase();
  }

  function shopLocale() {
    return String((window.Shopify && Shopify.locale) || document.documentElement.lang || '').toLowerCase();
  }

  function marketConfig() {
    const country = countryCode();
    if (country === 'ES') return { price: 399, codes: bundleCodesES, mode: 'price' };
    if (country === 'DE' || country === 'AT') return { price: 599, codes: bundleCodesDACH, mode: 'price' };
    if (country === 'CH') return { price: 600, codes: bundleCodesDACH, mode: 'price' };
    if (['NL','BE','LU','DK','SE','FI','IE'].includes(country)) return { codes: bundleCodesDACH, mode: 'variant' };
    if (shopLocale().indexOf('en') === 0) return { codes: bundleCodesINT, mode: 'variant' };
    return null;
  }

  function eligibleQuantity(cart) {
    const config = marketConfig();
    if (!config) return 0;
    return (cart.items || []).reduce(function (sum, item) {
      const productId = String(item.product_id || '');
      const variantId = String(item.variant_id || '');
      const price = Number(item.original_price);
      const eligible = config.mode === 'variant'
        ? eligibleProductIds.has(productId) && !premiumVariantIds.has(variantId)
        : eligibleProductIds.has(productId) && price === config.price;
      return sum + (eligible ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function desiredBundleCode(cart) {
    const config = marketConfig();
    if (!config) return '';
    const qty = eligibleQuantity(cart);
    if (qty < 2) return '';
    return config.codes[Math.min(qty, 30)] || '';
  }

  function discountApplications(cart) {
    const apps = [];
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      apps.push(app);
    });
    (cart.items || []).forEach(function (item) {
      (item.discount_allocations || []).forEach(function (allocation) {
        if (allocation.discount_application) apps.push(allocation.discount_application);
      });
    });
    return apps;
  }

  function currentBundleCode(cart) {
    const app = discountApplications(cart).find(function (discount) {
      const title = String(discount.title || '');
      return title.indexOf('PACKMEDPINS') === 0 || title.indexOf('PACKDACH') === 0 || title.indexOf('PACKINT') === 0 || title.indexOf('MPV6ES') === 0;
    });
    return app ? String(app.title) : '';
  }

  function nonBundleDiscountCodes(cart) {
    const codes = [];
    discountApplications(cart).forEach(function (discount) {
      const title = String(discount.title || '');
      if (discount.type === 'discount_code' && title && title.indexOf('PACKMEDPINS') !== 0 && title.indexOf('PACKDACH') !== 0 && title.indexOf('PACKINT') !== 0 && title.indexOf('MPV6ES') !== 0 && codes.indexOf(title) === -1) {
        codes.push(title);
      }
    });
    return codes;
  }

  function sectionPayload() {
    const sections = [];
    const main = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    if (main && main.dataset.id) sections.push(main.dataset.id);
    if (footer && footer.dataset.id) sections.push(footer.dataset.id);
    if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
    return sections;
  }

  function replaceSectionHtml(sections) {
    if (!sections) return;
    const parser = new DOMParser();

    const main = document.getElementById('main-cart-items');
    if (main && main.dataset.id && sections[main.dataset.id]) {
      const doc = parser.parseFromString(sections[main.dataset.id], 'text/html');
      const source = doc.querySelector('#main-cart-items .js-contents');
      const target = main.querySelector('.js-contents');
      if (source && target) target.innerHTML = source.innerHTML;
    }

    const footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id && sections[footer.dataset.id]) {
      const doc = parser.parseFromString(sections[footer.dataset.id], 'text/html');
      const source = doc.querySelector('#main-cart-footer .js-contents');
      const target = footer.querySelector('.js-contents');
      if (source && target) target.innerHTML = source.innerHTML;
    }

    if (sections['cart-icon-bubble']) {
      const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      const source = doc.querySelector('.shopify-section');
      const target = document.getElementById('cart-icon-bubble');
      if (source && target && target.parentElement) {
        const wrapped = source.querySelector('#cart-icon-bubble');
        if (wrapped) target.replaceWith(wrapped);
      }
    }
  }

  async function fetchCart() {
    const response = await fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    return response.json();
  }

  async function syncBundleDiscount(cart) {
    if (syncing) return syncing;

    syncing = (async function () {
      const state = cart || await fetchCart();
      const desired = desiredBundleCode(state);
      const current = currentBundleCode(state);

      if (desired === current) return state;

      const codes = nonBundleDiscountCodes(state);
      if (desired) codes.push(desired);

      const body = {
        discount: codes.join(',')
      };

      const sections = sectionPayload();
      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(window.routes && routes.cart_update_url ? routes.cart_update_url : '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      });

      const updated = await response.json();
      replaceSectionHtml(updated.sections);
      return updated;
    })().catch(function (error) {
      console.error('MedPins bundle sync:', error);
    }).finally(function () {
      syncing = null;
    });

    return syncing;
  }

  function syncProductBundleOffer(variant) {
    const offer = document.querySelector('[data-medpins-bundle-offer]');
    if (!offer || !variant) return;
    const rawPrice = variant.price && typeof variant.price === 'object' ? variant.price.amount : variant.price;
    const numeric = Number(rawPrice);
    const cents = numeric < 100 ? Math.round(numeric * 100) : Math.round(numeric);
    const config = marketConfig();
    const variantId = String(variant.id || '');
    offer.hidden = !config || (config.mode === 'price' ? cents !== config.price : premiumVariantIds.has(variantId));
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncBundleDiscount();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      syncBundleDiscount(event && event.cartData ? event.cartData : null);
    });

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant) {
        syncProductBundleOffer(event.data.variant);
      }
    });
  }

  document.addEventListener('click', function (event) {
    const checkout = event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!checkout || !syncing) return;

    event.preventDefault();
    syncing.finally(function () {
      window.location.href = '/checkout';
    });
  }, true);
})();